export default "__VITE_ASSET__243b3fb7__"